import * as React from 'react';
import { FormField, Input } from 'wix-style-react';
import { DataHooks } from '@src/constants/data-hooks';
import { InjectedTranslateProps, translate } from 'react-i18next';
import { TextAndStylePrivacyLinkMaxLength } from '@src/constants/constants';

const MAX_LEN = TextAndStylePrivacyLinkMaxLength;

interface Props extends InjectedTranslateProps {
  value: string;
  onChange: (value: string) => void;
}

const PrivacyLinkEditorBase = ({ t, value, onChange }: Props) => (
  <FormField
    label={t('text-and-display.privacy-link.title')}
    infoContent={t('text-and-display.privacy-link.tooltip')}
    charCount={MAX_LEN - value.length}
  >
    <Input
      dataHook={DataHooks.TextAndDisplayPrivacy}
      value={value}
      onChange={(event) => onChange(event.target.value)}
      maxLength={MAX_LEN}
    />
  </FormField>
);

export const PrivacyLinkEditor = translate()(PrivacyLinkEditorBase);
